var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.productType == 'DEVICE')?_c('v-icon',[_vm._v("mdi-devices")]):_vm._e(),(_vm.productType == 'ACCESSORY')?_c('v-icon',[_vm._v("mdi-tools")]):_vm._e(),(_vm.productType == 'SERVICE')?_c('v-icon',[_vm._v("mdi-currency-usd")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }